import React, {Component} from "react";
import {Icon, TextArea} from "bloomer";
import Card from "../../../elements/Card";
import {getGeneralBotResult} from "../../../api/models/Chatbot";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import InformationCard from "../../../elements/InformationCard";
import ModelContentContainer from "../../../elements/ModelContentContainer";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";
import "./style.css";
import Moment from "moment";

interface IChatbotModelState {
    loading: boolean;
    sessionId: string;
    message: string;
    conversation: any;
    errorMessage: string;
}

class ChatbotModel extends Component<{}, IChatbotModelState> {

    public MESSAGE_FOOTER_PREFIX = '<div class="feedflare"';

    public messagesContainerRef = React.createRef();

    public constructor(props: {}) {
        super(props);

        this.state = {
            loading: false,
            sessionId: Date.now() + Math.random().toString().substr(2),
            message: "",
            conversation: [],
            errorMessage: ""
        };
    }

    public componentDidMount() {
        SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.CHATBOT);
    }

    public handleMessageChange = (e: any) => {
        this.setState({
            message: e.target.value
        });
    };

    public handleMessageKeypress = (e: any) => {
        const code = e.which || e.keyCode;
        if (code === 13) {
            e.preventDefault();
            this.sendMessage();
        }
    };

    public addMessage = (message:any) => {
        const div: any = this.messagesContainerRef;
        if (div) {
            div.scroll(0, div.scrollHeight);
        }
        const conversation = this.state.conversation;
        conversation.push(message);
        this.setState({
            conversation
        }, () => {
            setTimeout(() => {
                if (div) {
                    div.scroll(0, div.scrollHeight);
                }
            }, 100);
        });
    };

    public sendMessage = async () => {
        if (this.state.loading || !this.state.message.trim()) {
            return;
        }

        this.addMessage({
            dateStr: Moment(new Date()).format('YYYY/MM/DD HH:mm:ss'),
            color: 'black',
            from: 'You',
            text: this.state.message.trim()
        });

        this.setState({
            loading: true,
            errorMessage: "",
            message: ""
        });

        let errorOccurred = false;

        const formData = new FormData();
        formData.append("in", this.state.message.trim());
        formData.append("SessionID", this.state.sessionId);

        const response = await getGeneralBotResult(formData).catch((error) => {
            if (ErrorUtils.requestLimitExceeded(error.response)) {
                this.setState({
                    loading: false
                });
                toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
            } else {
                this.setState({
                    loading: false,
                    errorMessage: "Couldn't send message."
                });
            }
            errorOccurred = true;
        });

        if (errorOccurred) {
            return;
        }

        if (response && response.data) {
            let message = response.data.out;
            const index = message.indexOf(this.MESSAGE_FOOTER_PREFIX);
            if (index !== -1) {
                message = message.substring(0, index);
            }
            this.addMessage({
                dateStr: Moment(new Date()).format('YYYY/MM/DD HH:mm:ss'),
                color: 'darkblue',
                from: 'Chatbot',
                text: message
            });
            this.setState({
                loading: false
            });
        } else {
            this.setState({
                loading: false,
                errorMessage: "Couldn't send message."
            });
        }

        SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.CHATBOT);
    };

    public render() {
        return <ModelContentContainer>
            <Card>
                <div
                    ref={(el: any) => {this.messagesContainerRef = el;}}
                    style={{
                        minHeight: '300px',
                        maxHeight: '400px',
                        overflowY: 'auto',
                        marginBottom: '10px'
                    }}
                >
                    {
                        this.state.conversation.length === 0 ? <div style={{
                            textAlign: 'center',
                            fontSize: '14px',
                            color: 'lightgrey'
                        }}>
                            Start of the conversation
                        </div> : <></>
                    }
                    {
                        this.state.conversation.map((m: any, index: any) => {
                            return <div key={index} style={{
                                marginBottom: '10px'
                            }}>
                                <p style={{
                                    padding: '0px 10px 0px 20px'
                                }}>
                                    <div
                                        style={{
                                            marginLeft: '-10px',
                                            color: m.color
                                        }}
                                    >
                                        <span style={{
                                            fontSize: '14px',
                                            opacity: 0.7
                                        }}>{m.dateStr}</span>{" - "}<b>{m.from}{": "}</b>
                                    </div>
                                    <div
                                        style={{
                                            padding: '10px',
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            border: '1px lightgrey solid',
                                            boxShadow: '1px 1px lightgrey'
                                        }}
                                        dangerouslySetInnerHTML={{__html: m.text}}
                                    />
                                </p>
                            </div>;
                        })
                    }
                </div>
                {
                    this.state.loading ? <div style={{textAlign: 'center', height: '20px', fontSize: '16px'}}>
                        <Icon className="fas fa-spinner fa-spin"/>
                    </div> : <div style={{height: '20px'}}/>
                }
                {
                    !this.state.loading && this.state.errorMessage ? <div>
                        <InformationCard>{this.state.errorMessage}</InformationCard>
                    </div> : <></>
                }
                <div style={{
                    margin: '10px 0',
                    borderTop: '1px solid lightgrey'
                }}>
                    <TextArea
                        rows={2}
                        autoFocus={true}
                        onChange={this.handleMessageChange}
                        onPaste={this.handleMessageChange}
                        onKeyPress={this.handleMessageKeypress}
                        value={this.state.message}
                        placeholder="Write a message"
                    />
                    <span style={{
                        margin: '0px 0px 5px 2px',
                        fontSize: '12px'
                    }}>Press Enter to send message</span>
                </div>
            </Card>
        </ModelContentContainer>;
    }
}

export default ChatbotModel;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Chatbot/ChatbotModel.tsx